import React, { useEffect } from 'react'
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CustomColumnChart = (props) => {

    const options = {
        chart: {
            type: 'column',
            height: 30 + '%',            
            margin: [65, 60, 30, 110],
            backgroundColor: 'transparent'	
        },
        title: {
            text: props.title,
            align: 'center',            
            y: 2,
            style: {                            
                fontSize: '14px',                
                textTransform: 'none'
            }
        },               
        credits: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            labels: {
                style: {
                    fontSize: '11px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: props.yTitle
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f} 대</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: props.seriesFormat
                }
            }
        },
        legend: {
            enabled: false               
        },
        series: [{
            
            name: props.seriesName,
            colorByPoint: true,
            data: props.data

        }]
    }
    
    useEffect(() =>{

    }, [])

    return (
        <HighchartsReact highcharts={Highcharts} options={options} />  
    )
  };
  
  export default CustomColumnChart